import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import CalendlyPopup from '../CalendlyPopup';
import { useCalendlyAndVideo } from '../../hooks/useCalendlyAndVideo';

const StaffingCTA = () => {
  const { isCalendlyOpen, openCalendly, closeCalendly } = useCalendlyAndVideo();

  return (
    <section className="py-24 px-6 relative">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-5xl md:text-6xl font-bold mb-6 text-white">
          Deliver Talent That's Ready—
          <br />
          <span className="text-cyan-400">Not Just Placed</span>
        </h2>
        <p className="text-xl text-gray-300 mb-12 max-w-4xl mx-auto">
          Traain helps staffing and recruiting firms prepare talent, prove readiness, and outperform competitors.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            size="lg"
            onClick={openCalendly}
            className="h-14 bg-cyan-500 text-black hover:bg-cyan-400 rounded-lg px-8 text-lg font-semibold transition-all duration-200 hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/50"
          >
            See Traain for Staffing & Recruiting
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </div>
      </div>
      
      <CalendlyPopup isOpen={isCalendlyOpen} onClose={closeCalendly} />
    </section>
  );
};

export default StaffingCTA;
